export default __webpack_public_path__ + "static/media/Pill.3bf29eff.png";